module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الإهداء"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الإهداء")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "01em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أهدي خلاصة هذا الكتاب إلى مَن أهدَتني الحياة، وعلَّمَتني كيف أناضل في سبيل تحقيق طموحي وأحلامي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وإلى الشخص الذي أنار عتمة طريقي، وكان لي الصديق الوفِيَّ، أطال الله في عمرهما (إلى أمِّي وأبي).")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وكيف أنسى مَن هُم انتصاراتي وأملي في هذه الدنيا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى أختي الصغيرة القويَّة، وإلى إخوتي الخمسة الذين هم سَندي وضلعي الذي لا يميل في الحياة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى القلَّة الذين استخلصتُهم في رحلة البحث عن ذاتي، الأوفياء هُم، وبالوعود صادقون، الرائعون الحقيقيُّون الذين لا يتغيَّرون مهما اختلفنا ومهما طال الزمن، مَن لهم مَوضع قَدم في قلبي (صديقاتي).")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be8e4d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 69
// module chunks = 0